import React from 'react'

const Loading = () => {
  return (
    <div className=" h-full">
      <div className='custom-loader'>

      </div>
      <p>
        Loading. . .
      </p>
    </div>
  )
}

export default Loading